import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Philosophy = () => {
    const containerRef = useRef(null);
    const text1Ref = useRef(null);
    const text2Ref = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {
            // Parallax image
            gsap.to(imageRef.current, {
                y: "20%",
                ease: "none",
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            });

            // Simple staggered text reveal
            const animateText = (elementRef, triggerRef) => {
                const words = elementRef.current.querySelectorAll('.word');
                gsap.from(words, {
                    y: 30,
                    opacity: 0,
                    duration: 1,
                    stagger: 0.05,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: triggerRef.current,
                        start: "top 80%",
                    }
                });
            };

            animateText(text1Ref, text1Ref);
            animateText(text2Ref, text2Ref);

        }, containerRef);

        return () => ctx.revert();
    }, []);

    // Helper to split text into words for animation
    const splitWords = (text) => {
        return text.split(' ').map((word, i) => (
            <span key={i} className="inline-block word mr-[0.25em]">{word}</span>
        ));
    };

    return (
        <section ref={containerRef} className="relative py-32 md:py-48 bg-[#0A0A14] overflow-hidden">
            <div
                ref={imageRef}
                className="absolute inset-0 bg-[url('/images/generated/philosophy_divide.png')] bg-cover bg-center opacity-15 scale-[1.2]"
            ></div>

            <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A14] via-transparent to-[#0A0A14]"></div>

            <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-16 flex flex-col gap-24">

                {/* Neutral statement — names the villain (the cloud) */}
                <div ref={text1Ref} className="max-w-xl text-[#F0EFF4]/40 font-light text-xl md:text-2xl leading-relaxed">
                    {splitWords("Most roofing contractors trust their customer data, their SOPs, and their revenue pipeline to someone else's server.")}
                </div>

                {/* Massive dramatic manifesto — the guide's stance */}
                <div ref={text2Ref} className="ml-auto w-full md:w-3/4 text-right">
                    <p className="text-[#F0EFF4] font-bold text-4xl md:text-5xl leading-tight inline-block text-left mb-4">
                        {splitWords("We built RoofClaw so yours")}
                    </p>
                    <br />
                    <p className="font-drama text-[#7B61FF] text-6xl md:text-8xl leading-[0.9] -mr-4 text-left md:text-right">
                        never has to leave your desk.
                    </p>
                </div>

            </div>
        </section>
    );
};

export default Philosophy;
